import {
  PopupPortal
} from "./chunk-UZDY5GA7.mjs";
import {
  useHover
} from "./chunk-EVE3IGZR.mjs";

// lib/components/tooltips/tooltips/tooltips.tsx
import classNames from "classnames";
import React, { useEffect, useMemo, useState } from "react";
import { usePopper } from "react-popper";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
var WithTooltips = ({
  Content,
  ...props
}) => {
  const { hovering, hoverSensor } = useHover();
  const [ref, setRef] = useState(null);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Content,
      {
        hoverSensor,
        hovering,
        setNodeRef: setRef
      }
    ),
    /* @__PURE__ */ jsx(Tooltips, { isActive: hovering, refElement: ref, ...props })
  ] });
};
var Tooltips = ({
  isActive,
  always = false,
  refElement,
  label,
  subLabel,
  layoutDependency,
  placement,
  cursor = false
}) => {
  const [active, setActive] = useState(isActive);
  const [ref, setRef] = useState(null);
  const [arrowRef, setArrowRef] = useState(null);
  const [offset, setOffset] = useState([0, 0]);
  const options = useMemo(
    () => ({
      placement,
      modifiers: [
        { name: "arrow", options: { element: arrowRef } },
        cursor ? {
          name: "offset",
          enabled: true,
          options: { offset: [offset[0], offset[1]] }
        } : {}
      ]
    }),
    [arrowRef, cursor, offset, placement]
  );
  const { attributes, styles, state, update } = usePopper(
    refElement,
    ref,
    options
  );
  useEffect(() => {
    if (active || !refElement || !cursor) return;
    const fn = (e) => {
      const rect = refElement.getBoundingClientRect();
      setOffset([e.clientX - rect.left, 0]);
    };
    addEventListener("mousemove", fn);
    return () => removeEventListener("mousemove", fn);
  }, [active, refElement, cursor]);
  useEffect(() => {
    update && update();
  }, [label, subLabel, layoutDependency]);
  useEffect(() => {
    active !== isActive && setActive(isActive);
  }, [isActive, setActive]);
  if (!always && !active && !isActive) {
    return null;
  }
  return /* @__PURE__ */ jsx(PopupPortal, { children: /* @__PURE__ */ jsx(
    ToolTipsLabel,
    {
      style: {
        opacity: always || active ? 1 : 0,
        ...styles.popper
      },
      ref: setRef,
      label,
      subLabel,
      placement: state?.placement,
      arrowRef: setArrowRef,
      arrowStyle: styles.arrow,
      ...attributes.popper
    }
  ) });
};
var ToolTipsLabel = React.forwardRef(function ToolTipsLabel2({ label, subLabel, arrowRef, arrowStyle, ...props }, ref) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ...props,
      className: classNames("tooltip popper-box py-1 px-2", props.className),
      style: {
        ...props.style,
        zIndex: 999,
        margin: "0.125em",
        transition: "opacity ease-in-out 0.2s",
        userSelect: "none",
        pointerEvents: "none",
        background: "#1A2631",
        color: "#FFFFFF",
        borderRadius: "0.25em",
        fontSize: "1em",
        fontWeight: 700,
        boxShadow: "rgb(26 38 49 / 60%) 0px 1px 4px"
      },
      ref,
      children: [
        label && /* @__PURE__ */ jsx("div", { children: label }),
        subLabel && /* @__PURE__ */ jsx("div", { style: { color: "rgba(255, 255, 255, 0.7)", fontSize: "0.75em" }, children: subLabel }),
        /* @__PURE__ */ jsx("div", { className: "popper-arrow", ref: arrowRef, style: arrowStyle })
      ]
    }
  );
});

export {
  WithTooltips,
  Tooltips,
  ToolTipsLabel
};
